import {
  RequestedFields,
  Error,
} from '@wix/ambassador-ecom-v1-ecommerce-settings/types';

export function hasRequestedFieldError(
  errors: Error[] | undefined,
  expectedRequestedField: RequestedFields,
) {
  return errors?.some(
    ({ requestedField }) => requestedField === expectedRequestedField,
  );
}
